import { jsx as _jsx } from "react/jsx-runtime";
// @flow
import React from 'react';
import { Wrapper, Badge } from './styles';
var DiscountBadge = function () { return (_jsx(Wrapper, { children: _jsx(Badge, { icon: 'discountSmall' }, void 0) }, void 0)); };
export default DiscountBadge;
